import React from "react";
import {LoadLocationDetailsEpic, UpdateLocationTable, UpdateLocationPhotoEpic, UpdateLocationPropertyEpic, SyncLocationTables, GetLocationTenderTypesEpic} from '../../actions/location.actions';
import {connect} from 'react-redux'
import { withRouter, Switch, Route } from 'react-router-dom'
import {push} from 'react-router-redux';
import {Card, CardHeader, CardText} from 'material-ui/Card';
import CircularProgress from 'material-ui/CircularProgress';
import LocationTables from '../../components/LocationTables';
import LocationTableDialog from './LocationTableDialog';
import LocationPhotos from '../../components/LocationPhotos';
import PhotoUpload from './../PhotoUpload';
import LocationUsers from './LocationUsers';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import {LoadCountriesEpic} from '../../actions/reference.actions';
import LocationPaymentSettings from './LocationPaymentSettings';
import Toggle from 'material-ui/Toggle';
import ErrorBlock from '../../components/ErrorBlock';
import WebsiteContentField from '../../components/WebsiteContentField';
import RaisedButton from 'material-ui/RaisedButton';
import {RoleContent} from '../../components/RoleRoute';
import {FeatureContent} from '../../components/FeatureRoute';
import * as moment from 'moment-timezone';

const features = {
  items: 'Split by item',
  seats: 'Split by seats',
  multiselect: 'Pay multiple bills',
  tab: 'Start tab'
}

const styles = {
        section: {
          margin: 20
        },
        prefixIcon: {
          position:'relative',
          top: 8,
          marginRight: 3
        },
        toggle: {
          marginBottom: 16,
        }
      };

export class LocationDetails extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      showEdit: false,
      showUploadDialog: false,
      table: null,
      photoProperty: '',
      stateChanged: false
    };
    this.onUploadPhoto = this.onUploadPhoto.bind(this);
    this.onPhotoReady = this.onPhotoReady.bind(this);
    this.updateFeatures = this.updateFeatures.bind(this);
  }
  componentDidMount() {
    this.props.loadLocationDetails(this.props.locationId);
    this.props.getTenderTypes(this.props.locationId);
    this.props.load
     if(!this.props.countryDataLoaded) {
        this.props.loadCountries();
      }
  }

  updateTenderType = (value) => {
    this.editState('tenderType', value)
  }
  editState(prop, value) {
    this.setState({ 
      [prop]:value, 
      stateChanged: true,
      changed: {...this.state.changed, [prop]: true}
    });
  }

  saveChanges(){
    let updates = Object.keys(this.state.changed).reduce((p, key) => {
      p[key] = this.state[key];
      return p;
    },{});

    this.props.updateLocation(this.props.location._id,updates).then(()=> {
      this.setState({changed: {}, stateChanged: false});
    });
  }

  componentWillReceiveProps(newProps){
    if (newProps.location){
      this.setState({...newProps.location, latitude: newProps.location.geometry? newProps.location.geometry.coordinates[1]:null,longitude: newProps.location.geometry? newProps.location.geometry.coordinates[0]:null});
    }
  }

  onEditTable = (table) => {
    console.log({
      table,
      showEdit: true
    });
    this.setState({
      table,
      showEdit: true
    });
  }

  onUploadPhoto = (photoProperty) => {
    this.setState({showUploadDialog: true, photoProperty});
  }

  onCloseUpload = () => {
    this.setState({showUploadDialog: false});
  }

  onBeaconUpdated = (data) => {
    this.setState({showEdit: false});
    this.props.updateTable(data.locationId,data.tableId,data.beaconId, data.name);
  }

  onPhotoReady(url, amsData){
    if (this.state.photoProperty){
      this.props.updatePhoto(this.props.location._id, this.state.photoProperty, url, amsData);
    }
  }

  onUpdateDiscoverVisible(e, checked){
    this.props.updateLocation(this.props.location._id, {discoverVisible: checked});
  }

  locationFeatures(values) {
    return Object.keys(features).map(fk => (<MenuItem 
        key={fk} 
        insetChildren={true} 
        checked={values && values.indexOf(fk) > -1}
        value={fk} 
        primaryText={features[fk]}
      />));
  }

  updateFeatures(e,index,values) {
    this.props.updateLocation(this.props.location._id, {features: values});
  }

  handleCountryInput = (selected) => {
    this.setState({
      countryCode: selected.Code
    });
  }

  handleStateInput = (selected) => {
    this.setState({
      stateCode: selected.Code
    });
  }

  Field = ({propName, label, icon, ...props}) => {
    return (
       <WebsiteContentField icon={icon} label={label} value={this.state[propName]} onChange={(value)=> this.editState(propName,value)} type="text" finePrint="" />
    );
  }
  DropDownField = ({propName, label, icon, options, ...props}) => {
    return (
       <WebsiteContentField icon={icon} label={label} value={this.state[propName]} options={options} onChange={(value)=> this.editState(propName,value)} type="dropdown" finePrint="" />
    );
  }

  locationDetails() {

    let styles = {
        contentFieldLabel: {
        width:200,
        lineHeight: 30,
        paddingLeft: 20,
        ontSize: 18,
        fontWeight: 400,
      }
    };
    const currentCountry = this.props.countryData.find(cd=>cd.Code === this.state.countryCode);
    const currentState =  this.state.stateCode && currentCountry? currentCountry.States.find(s=>s.Code === this.state.stateCode) : null;
    const currentTimezone = this.state.timezone;
    return (<div>
            
            <Card>
              <CardHeader title="Restaurant Details" titleStyle={{fontWeight: 'bold', color: '#1cb7ff'}}/>
              <CardText>
                <this.Field propName="name" icon="icon-icon-quotes" label="Name*" fullWidth={true}/><br/>
                <this.Field propName="description" icon="icon-icon-quotes" label="Description" fullWidth={true}/><br/>
                <this.Field propName="phoneNumber" icon="icon-icon-phone" label="Phone Number*"/><br/>
                <this.Field propName="hours" icon="icon-icon-clock" label="Operating Hours"/><br/>
                <this.Field propName="contactPhone" icon="icon-icon-phone" label="Phone Number"/><br/>
                <this.Field propName="reservationsPhone" icon="icon-icon-phone" label="Reservations Phone"/><br/>
                <this.Field propName="reservationsEmail" icon="icon-icon-mail" label="Reservations Email"/><br/>
                <this.Field propName="generalManagerName" icon="icon-icon-quotes" label="Manager Name"/><br/>
                <this.Field propName="generalManagerPhone" icon="icon-icon-phone" label="Manager Phone"/><br/>
                <this.Field propName="generalManagerEmail" icon="icon-icon-mail" label="Manager Email"/><br/>
                <this.Field propName="menuUrl" icon="icon-icon-link" label="Menu URL"/><br/>
                <this.Field propName="websiteUrl" icon="icon-icon-link" label="Website URL"/><br/>
                <this.Field propName="reservationUrl" icon="icon-icon-link" label="Reservations URL"/><br/>
                <br/>
                <this.Field propName="tenderType" label="Payment Tender Type"/><br/>
              </CardText>
              
            </Card><br/>
            <Card>
              <CardHeader 
                title="Address" 
                titleStyle={{fontWeight: 'bold', color: '#1cb7ff'}} 
                actAsExpander={true}
                showExpandableButton={true}
              />
              <CardText expandable={true}>
                <this.Field propName="streetAddress" icon="fa-map-marker" label="Street Addresss*" fullWidth={true}/><br/>
                <this.Field propName="city" icon="fa-map-marker" label="City*" fullWidth={true}/><br/>
                <this.Field propName="zip" icon="fa-map-marker" label="Postal Code*"/><br/>
                {this.props.countryData && this.props.countryData.length > 0? 
                  <WebsiteContentField icon="fa-map-marker" label="Country*" value={currentCountry? currentCountry.Name : this.state.countryCode} type="autocomplete" finePrint="" dataSource={this.props.countryData} onNewRequest={this.handleCountryInput} dataSourceConfig={{text:'Name', value: 'Code'}}  />
                  : null 
                } <br/>
                <WebsiteContentField icon="fa-map-marker" disabled={!currentCountry} label="State / Province*" value={currentState? currentState.Name : ''} type="autocomplete" finePrint="" dataSource={currentCountry? currentCountry.States: []} onNewRequest={this.handleStateInput} dataSourceConfig={{text:'Name', value: 'Code'}} />
                <br/>
                <this.Field propName="latitude" icon="fa-map-marker" label="Latitude"/><br/>
                <this.Field propName="longitude" icon="fa-map-marker" label="Longitude"/><br/>
                <this.DropDownField propName="timezone" icon="fa-map-marker" label="Timezone*" value={currentTimezone} options={moment.tz.names()}/>
              </CardText>

            </Card><br/>
            <RoleContent roles={['iQ Admin']}>
            <Card>
              <CardHeader title="Discover Details" titleStyle={{fontWeight: 'bold', color: '#1cb7ff'}}/>
              <CardText>
                <this.Field propName="priceIndicator" label="Price Indicator"/><br/>
                <this.Field propName="tags" label="Tags"/><br/>
                <this.Field propName="influencerName" label="Influencer Name"/><br/>
                <this.Field propName="influencerScreenName" label="Influencer Screen Name"/><br/>
                <this.Field propName="influencerReview" label="Influencer Review" fullWidth={true}/><br/>
                <this.Field propName="influencerUrl" label="Influencer URL" fullWidth={true}/><br/>
                <this.Field propName="influencerPhoto" label="Influencer Photo"/> <RaisedButton onClick={() => this.onUploadPhoto('influencerPhoto')}>Upload Photo</RaisedButton> <br/>
              </CardText>
              
            </Card><br/>
            <Card>
            <CardHeader title="Waitlist" titleStyle={{fontWeight: 'bold', color: '#1cb7ff'}}/>
            <CardText>
              <this.Field icon="icon-icon-quotes" propName="waitlistUpNextMessage" label="You\'re Up Next"/><br/>
              <this.Field icon="icon-icon-quotes" propName="waitlistCancelMessage" label="Cancel Message"/><br/>
            </CardText>
            
          </Card><br/>
            </RoleContent>
            <Card>
              <CardText>
              <CardHeader title={<span><i className="icon-icon-gear"></i>&nbsp;Enabled Services</span>} titleStyle={{fontWeight: 'bold', color: '#1cb7ff'}}/>
              <FeatureContent features={['ready']}>
                <WebsiteContentField label="Mobile Payments" value={this.featureFlag('ready')} onChange={(data)=> this.toggleFeature('ready', data)} type="toggle" finePrint="" />
              </FeatureContent>
              <FeatureContent features={['waitlist']}>
                <WebsiteContentField label="Waitlist" value={this.featureFlag('waitlist')} onChange={(data)=> this.toggleFeature('waitlist', data)} type="toggle" finePrint="" />
              </FeatureContent>
              <FeatureContent features={['seatingManagement']}>
                <WebsiteContentField label="Seating Mangement" value={this.featureFlag('seatingMangement')} onChange={(data)=> this.toggleFeature('seatingMangement', data.value)} type="toggle" finePrint="" />
              </FeatureContent>
              </CardText>
            </Card>
            <br/>
            <Card>
              <CardHeader title="Settings" titleStyle={{fontWeight: 'bold', color: '#1cb7ff'}}/>
                
              <CardText>
                <Toggle
                  label="Visible in Discovery"
                  style={styles.toggle}
                  toggled={this.state.discoverVisible}
                  labelPosition="right"
                  onToggle={(event,checked) => this.editState('discoverVisible', checked)}
                />
                <SelectField
                  multiple={true}
                  hintText="Select Enabled Features"
                  floatingLabelText="Enabled Features"
                  floatingLabelFixed={true}
                  value={this.props.location.features}
                  onChange={this.updateFeatures}>{this.locationFeatures(this.props.location.features)}
                </SelectField>
              </CardText>
            </Card> 
            </div>);
  }

  featureFlag(featureName) {
    return this.state.services? 
     !!this.state.services[featureName]
     :
     false;
  }

  syncTables() {
    this.props.syncTables(this.props.location._id);
  }

  toggleFeature(featureName, checked){
    
    let newServices = {};
    if (this.state.services){
      newServices = {...this.state.services};
    }
    newServices[featureName] = checked;
    this.editState('services', newServices);
  }

  render() {
    if (this.props.loading) {
      return  <div style={{textAlign: 'center'}}><CircularProgress/></div>;
    }

    if (this.props.error) {
      return <ErrorBlock errorText="Unable to retrieve location details at this time."/>
    }

    //Initial mounting of the component doesn't have an error, a location nor is it loading yet. Return some default content
    if (!this.props.location){
      return <span></span>;
    }
    const styles = {
      saveTextSaved: {
        color: '#9E9E9E',
        fontSize: 14,
        fontWeight: '600',
        justifyContent: 'flex-start',
        flexGrow: '1',
      },
      primaryButton: {
        borderRadius: '4px',
        minHeight: 46,
        fontSize: 18,
        fontWeight: '600',
        textTransform: 'capitalize',
        margin: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minWidth: 56,
      }
    };

    const locationObj = this.state;

    return (
     <div>
        <div className={'save-area'} style={{ backgroundColor:'#EFEFEF', borderBottom:'1px solid #D7D7D7' }}>
            { this.state.stateChanged ? <div style={styles.saveTextSaved}>Changes have not been saved.</div> : <div style={styles.saveTextSaved}>Changes have been saved.</div> }
            <RaisedButton disabled={!this.state.stateChanged} buttonStyle={styles.primaryButton} labelStyle={styles.primaryButton} overlayStyle={styles.primaryButton} style={{boxShadow:'none'}} onClick={()=>this.saveChanges()} label="Save" primary={true}/>
        </div>
        <CardHeader
          title={this.props.location.name}
          subtitle={this.props.location.company.name}
          avatar={this.props.location.company.logo}
          />
        <Switch> 
          <Route path='/location/:locationId/details' render={() => this.locationDetails()}/>
          <Route path='/location/:locationId/paymentdata' render={() => (<LocationPaymentSettings selectedLocation={locationObj} onTenderTypeChange={this.updateTenderType}/>)}/>
          <Route path='/location/:locationId' exact={true} render={() => this.locationDetails()}/>
          <Route path='/location/:locationId/tables' render={()=>(<LocationTables tables={this.props.location.tables} showEdit={this.onEditTable}/>)}/>
          <Route path='/location/:locationId/photos' render={()=>(<LocationPhotos location={this.props.location} onUpload={this.onUploadPhoto}/>)}/>
          <Route path='/location/:locationId/users' render={()=>(<LocationUsers locationId={this.props.location.iqEntityId}/>)}/>
        </Switch>
        <RoleContent roles={['iQ Admin']}>
          <RaisedButton buttonStyle={styles.primaryButton} labelStyle={styles.primaryButton} overlayStyle={styles.primaryButton} style={{boxShadow:'none'}} onClick={()=>this.syncTables()} label="Start Table Sync" primary={true}/>
        </RoleContent>
        {this.state.showEdit ? <LocationTableDialog show={this.state.showEdit} table={this.state.table} beaconUpdated={this.onBeaconUpdated}/> : null}
        {this.state.showUploadDialog ? <PhotoUpload show={this.state.showUploadDialog} closeDialog={this.onCloseUpload} photoReady={this.onPhotoReady}/>: null}
      </div>);
  }
}

let mapStateToProps = ({locationsEndpoint, referenceData},{match}) => ({
  loading: locationsEndpoint.fetchInProgress,
  error: locationsEndpoint.fetchError,
  location: locationsEndpoint.locations[match.params.locationId],
  locationId: match.params.locationId,
  countryDataLoaded: referenceData.countriesLoaded,
  countryDataLoading: referenceData.fetchInProgress,
  countryData: referenceData.countries
})

let mapDispatchToProps = (dispatch) => ({
  loadLocationDetails : (locationId) => dispatch(LoadLocationDetailsEpic(locationId)),
  navigateLocation: (locationId) => dispatch(push(`/location/${locationId}/details`)),
  updateTable: (locationId, tableId, beaconId, name) => dispatch(UpdateLocationTable(locationId, tableId, beaconId, name)),
  updatePhoto: (locationId, photoProperty, url, amsData) => dispatch(UpdateLocationPhotoEpic(locationId,photoProperty,url, amsData)),
  updateLocation: (locationId, updates) => dispatch(UpdateLocationPropertyEpic(locationId, updates)),
  loadCountries: () => dispatch(LoadCountriesEpic()),
  syncTables: (locationId) => dispatch(SyncLocationTables(locationId)),
  getTenderTypes: (locationId) => dispatch(GetLocationTenderTypesEpic(locationId))
});

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(LocationDetails));



// WEBPACK FOOTER //
// ./src/containers/Locations/LocationDetails.js